export enum CardStatus {
  OK = 'OK',
  ERROR = 'ERROR',
}
